(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[99],{

/***/ 2099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LandingPage": function() { return /* binding */ LandingPage; },
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ travel_insurance; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(7729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/pages/InsuranceLanding/PreloadImages.tsx




var PreloadImages = function PreloadImages(pageProps) {
  var _pageProps$data, _pageProps$data$claim, _pageProps$data2, _pageProps$data2$trav, _pageProps$data3, _pageProps$data3$secu, _pageProps$data3$secu2, _pageProps$data4, _pageProps$data4$secu, _pageProps$data4$secu2, _pageProps$data$secur;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
    "data-test-id": "PreloadImages-Head",
    children: [(pageProps === null || pageProps === void 0 ? void 0 : (_pageProps$data = pageProps.data) === null || _pageProps$data === void 0 ? void 0 : (_pageProps$data$claim = _pageProps$data.claimSettlementText) === null || _pageProps$data$claim === void 0 ? void 0 : _pageProps$data$claim.icon) && /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      href: "".concat(pageProps.data.claimSettlementText.icon),
      as: "image",
      "data-test-id": "PreloadImages-link"
    }), (pageProps === null || pageProps === void 0 ? void 0 : (_pageProps$data2 = pageProps.data) === null || _pageProps$data2 === void 0 ? void 0 : (_pageProps$data2$trav = _pageProps$data2.travelSearchBanner) === null || _pageProps$data2$trav === void 0 ? void 0 : _pageProps$data2$trav.icon) && /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      href: "".concat(pageProps.data.travelSearchBanner.icon),
      as: "image",
      "data-test-id": "PreloadImages-link"
    }), (pageProps === null || pageProps === void 0 ? void 0 : (_pageProps$data3 = pageProps.data) === null || _pageProps$data3 === void 0 ? void 0 : (_pageProps$data3$secu = _pageProps$data3.secureTravData) === null || _pageProps$data3$secu === void 0 ? void 0 : (_pageProps$data3$secu2 = _pageProps$data3$secu[0]) === null || _pageProps$data3$secu2 === void 0 ? void 0 : _pageProps$data3$secu2.travImg) && /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      href: "".concat(pageProps.data.secureTravData[0].travImg),
      as: "image",
      "data-test-id": "PreloadImages-link"
    }), (pageProps === null || pageProps === void 0 ? void 0 : (_pageProps$data4 = pageProps.data) === null || _pageProps$data4 === void 0 ? void 0 : (_pageProps$data4$secu = _pageProps$data4.secureTravData) === null || _pageProps$data4$secu === void 0 ? void 0 : (_pageProps$data4$secu2 = _pageProps$data4$secu[1]) === null || _pageProps$data4$secu2 === void 0 ? void 0 : _pageProps$data4$secu2.travImg) && /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      href: "".concat((_pageProps$data$secur = pageProps.data.secureTravData) === null || _pageProps$data$secur === void 0 ? void 0 : _pageProps$data$secur[1].travImg),
      as: "image",
      "data-test-id": "PreloadImages-link"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      href: "https://tripmoneycmsimgak.mmtcdn.com/img/Search_Icon_ffe4fbfcc2.svg",
      as: "image",
      "data-test-id": "PreloadImages-link"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      href: "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_5d58cf6783.svg",
      as: "image",
      "data-test-id": "PreloadImages-link"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      href: "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Up_Blue_21102e8ed6.svg",
      as: "image",
      "data-test-id": "PreloadImages-link"
    })]
  });
};

/* harmony default export */ var InsuranceLanding_PreloadImages = (PreloadImages);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/index.tsx + 53 modules
var components = __webpack_require__(8990);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(7109);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/index.tsx + 65 modules
var static_components = __webpack_require__(5148);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(2874);
// EXTERNAL MODULE: ../../node_modules/@growth/dweb-footer/dist/growth-dweb-footer.esm.js
var growth_dweb_footer_esm = __webpack_require__(6147);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var isomorphic_utils_src = __webpack_require__(4928);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/index.ts + 2 modules
var hooks = __webpack_require__(8619);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/pages/InsuranceLanding/InsuranceLanding.style.ts



var InsuranceLandingPageMainWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceLandingstyle__InsuranceLandingPageMainWrapper",
  componentId: "sc-1l4dje5-0"
})(["background-image:linear-gradient(rgba(5,19,34,1),rgba(21,69,124,1));background-size:100% 990px;background-repeat:no-repeat;padding-top:16px;position:relative;z-index:2;@media ", "{background-image:none;padding-top:0px;}"], isomorphic_utils_src.deviceType.mobile);
var InsuranceGiLandingPageMainWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceLandingstyle__InsuranceGiLandingPageMainWrapper",
  componentId: "sc-1l4dje5-1"
})(["padding-top:16px;position:relative;z-index:2;&:after{content:\"\";position:absolute;top:240px;width:100%;left:0;background-color:#eff3f8;height:1200px;z-index:1;}:before{content:\"\";position:absolute;top:0;width:100%;left:0;background-image:url(\"https://tripmoneycmsimgak.mmtcdn.com/img/Group_1244831888_401a4765df.png\");background-size:100% 382px;background-repeat:no-repeat;height:382px;z-index:2;}@media ", "{background-image:none;padding-top:0px;&:after{background-color:transparent;}}"], isomorphic_utils_src.deviceType.mobile);
var PersuasionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceLandingstyle__PersuasionWrapper",
  componentId: "sc-1l4dje5-2"
})(["width:1200px;margin:0 auto;", "{max-width:60%;}"], static_components/* H3TagStyle */.KO);
var LandingPageRightWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceLandingstyle__LandingPageRightWrapper",
  componentId: "sc-1l4dje5-3"
})(["display:flex;flex-direction:column;gap:24px;"]);
var GiFooterWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceLandingstyle__GiFooterWrap",
  componentId: "sc-1l4dje5-4"
})(["width:100%;"]);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/pages/InsuranceLanding/InsuranceBottomComp.tsx









var data = [{
  title: "Popular Flight Sectors",
  links: [{
    text: "Kolkata to Delhi Flight",
    url: "https://www.goibibo.com/flights/kolkata-to-delhi-flights/"
  }, {
    text: "Hyderabad to Delhi Flight",
    url: "https://www.goibibo.com/flights/hyderabad-to-delhi-flights/"
  }]
}];

var InsuranceBottomComp = function InsuranceBottomComp(_ref) {
  var _footerInfo$filter$ma, _footerInfo$filter;

  var bottomCompData = _ref.bottomCompData,
      footerInfo = _ref.footerInfo;
  var context = (0,hooks/* usePartnerContext */.X)();
  var device = (0,src/* useBreakpointV2 */.bU)();
  var TravelInsData = bottomCompData.TravelInsData,
      safeSecureTravel = bottomCompData.safeSecureTravel,
      whatsCovered = bottomCompData.whatsCovered,
      claimYourInsurance = bottomCompData.claimYourInsurance,
      testimonials = bottomCompData.testimonials,
      faq = bottomCompData.faq,
      customNumbers = bottomCompData.customNumbers,
      crossSell = bottomCompData.crossSell,
      offers = bottomCompData.offers,
      seoContent = bottomCompData.seoContent; //TODO: check for if(footerInfo) and remove optional chaining to improve performance

  var footerLinks = (_footerInfo$filter$ma = footerInfo === null || footerInfo === void 0 ? void 0 : (_footerInfo$filter = footerInfo.filter(function (data) {
    return data.type === "section";
  })) === null || _footerInfo$filter === void 0 ? void 0 : _footerInfo$filter.map(function (item, index) {
    var _item$links$map, _item$links;

    return {
      id: index.toString(),
      label: item.title || "",
      listPoints: (_item$links$map = item === null || item === void 0 ? void 0 : (_item$links = item.links) === null || _item$links === void 0 ? void 0 : _item$links.map(function (link, i) {
        return {
          id: i.toString(),
          label: link.title || "",
          link: link.url || ""
        };
      })) !== null && _item$links$map !== void 0 ? _item$links$map : [],
      icon: ""
    };
  })) !== null && _footerInfo$filter$ma !== void 0 ? _footerInfo$filter$ma : [];
  var footerHeading = footerInfo === null || footerInfo === void 0 ? void 0 : footerInfo.find(function (data) {
    return data.type === "rich-text";
  });
  var footerCopyrightData = footerInfo === null || footerInfo === void 0 ? void 0 : footerInfo.find(function (data) {
    return data.type === "footnote";
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [customNumbers && /*#__PURE__*/(0,jsx_runtime.jsx)(components.InsuranceStats, {
      data: customNumbers,
      "data-test-id": "InsuranceBottomComp-InsuranceStats"
    }), offers && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ExclusiveOffers, {
      data: offers,
      "data-test-id": "InsuranceBottomComp-ExclusiveOffers"
    }), TravelInsData && /*#__PURE__*/(0,jsx_runtime.jsx)(components.WhyBuyTravIns, {
      title: TravelInsData.title,
      info: TravelInsData.info,
      data: TravelInsData.featureCard,
      "data-test-id": "InsuranceBottomComp-WhyBuyTravIns"
    }), safeSecureTravel && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SafenSecureTrav, {
      data: safeSecureTravel.safeTravCrd,
      title: safeSecureTravel.title,
      "data-test-id": "InsuranceBottomComp-SafenSecureTrav"
    }), whatsCovered && /*#__PURE__*/(0,jsx_runtime.jsx)(components.WhatsCovered, {
      data: whatsCovered.travCrd,
      title: whatsCovered.title,
      info: whatsCovered.info,
      "data-test-id": "InsuranceBottomComp-WhatsCovered"
    }), claimYourInsurance && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ClaimYourInsurance, {
      title: claimYourInsurance.title,
      info: claimYourInsurance.info,
      data: claimYourInsurance.claimData,
      "data-test-id": "InsuranceBottomComp-ClaimYourInsurance"
    }), device == "lg" && crossSell && /*#__PURE__*/(0,jsx_runtime.jsx)(PersuasionWrapper, {
      "data-test-id": "InsuranceBottomComp-PersuasionWrapper",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.PersuasionBannerInsurance, {
        crossSell: crossSell,
        btnHandler: function btnHandler() {
          context === isomorphic_utils_src.PARTNER.GI ? window.open("https://tripmoney.goibibo.com/partners/gi/forex/listing?utm_source=insurance_gi&utm_medium=desktop", "_blank") : window.open("https://www.makemytrip.com/forex", "_blank");
        } // info={persuasionBannerMob.info}
        ,
        "data-test-id": "InsuranceBottomComp-PersuasionBannerInsurance"
      })
    }), testimonials && /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingTestimonials, {
      customTitle: testimonials === null || testimonials === void 0 ? void 0 : testimonials.title,
      test: testimonials === null || testimonials === void 0 ? void 0 : testimonials.testimonialData,
      "data-test-id": "InsuranceBottomComp-LandingTestimonials"
    }), seoContent && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SeoContent, {
      seoContent: seoContent,
      "data-test-id": "InsuranceBottomComp-SeoContent"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingFaq, {
      customTitle: faq === null || faq === void 0 ? void 0 : faq.title,
      faq: faq === null || faq === void 0 ? void 0 : faq.faqList,
      "data-test-id": "InsuranceBottomComp-LandingFaq"
    }), (bottomCompData === null || bottomCompData === void 0 ? void 0 : bottomCompData.interlinkingBlock) && /*#__PURE__*/(0,jsx_runtime.jsx)(components.InterlinkingBlock, {
      interlinkingBlock: bottomCompData === null || bottomCompData === void 0 ? void 0 : bottomCompData.interlinkingBlock,
      "data-test-id": "InsuranceBottomComp-InterlinkingBlock"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.Breadcrumb, {
      hostname: context === isomorphic_utils_src.PARTNER.GI ? "www.goibibo.com" : "www.makemytrip.com",
      "data-test-id": "InsuranceBottomComp-Breadcrumb"
    }), context === isomorphic_utils_src.PARTNER.GI && device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(GiFooterWrap, {
      "data-test-id": "InsuranceBottomComp-GiFooterWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(growth_dweb_footer_esm/* Footer */.$, {
        data: data,
        adobe: "",
        "data-test-id": "InsuranceBottomComp-Footer"
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingFooter, {
      playStoreImgURI: "https://tripmoneycmsimgak.mmtcdn.com/img/play_Store_Icon_ddbbe2de64.png",
      appStoreImgURI: "https://tripmoneycmsimgak.mmtcdn.com/img/app_Store_Icon_07d258a1b2.png",
      facebookImgURI: "https://tripmoneycmsimgak.mmtcdn.com/img/fb_Icon_8eab71f726.png",
      linkedInImgURI: "https://tripmoneycmsimgak.mmtcdn.com/img/Linkedin_Icon_fec59ba5c7.png",
      twitterImgURI: "https://tripmoneycmsimgak.mmtcdn.com/img/twitter_Icon_760f145ad2.png",
      footerData: footerLinks,
      footerHeading: footerHeading,
      footerCopyrightData: footerCopyrightData,
      "data-test-id": "InsuranceBottomComp-LandingFooter"
    })]
  });
};

/* harmony default export */ var InsuranceLanding_InsuranceBottomComp = (InsuranceBottomComp);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 7 modules
var insurance = __webpack_require__(2182);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/navigation/index.ts + 3 modules
var navigation = __webpack_require__(1908);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 2 modules
var utils = __webpack_require__(3621);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravelDetails/TravellingToShimmer.tsx + 1 modules
var TravellingToShimmer = __webpack_require__(2915);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/pages/InsuranceLanding/InsuranceLandingShimmer.tsx



 //import Header from 'gi-happy-header/ssr/header';
//import { Header  } from 'pwa-mmt-ui-header/ssr/header';




var InsuranceLandingShimmer = function InsuranceLandingShimmer() {
  var device = (0,src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* DesktopLayout */.S_, {
      alignCenter: true,
      rightSectionHeight: "unset",
      leftSectionHeight: true,
      landingMargin: true,
      leftComp: /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(static_components/* FlexComp */.bA, {
          gap: "8px",
          flexDirection: "column",
          "data-test-id": "InsuranceLandingShimmer-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* Shimmer */.qm, {
            height: "55px",
            width: device == "lg" ? "375px" : "100px",
            "data-test-id": "InsuranceLandingShimmer-Shimmer"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* Shimmer */.qm, {
            height: "55px",
            width: "100%",
            "data-test-id": "InsuranceLandingShimmer-Shimmer"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* Shimmer */.qm, {
          height: device == "lg" ? "20px" : "10px",
          width: device == "lg" ? "248px" : "100%",
          "data-test-id": "InsuranceLandingShimmer-Shimmer"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* Shimmer */.qm, {
          height: device == "lg" ? "80px" : "40px",
          width: "100%",
          "data-test-id": "InsuranceLandingShimmer-Shimmer"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* Shimmer */.qm, {
          height: device == "lg" ? "80px" : "40px",
          width: "100%",
          "data-test-id": "InsuranceLandingShimmer-Shimmer"
        })]
      }),
      rightComp: /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToShimmer/* default */.Z, {
        "data-test-id": "InsuranceLandingShimmer-TravellingToShimmer"
      }),
      "data-test-id": "InsuranceLandingShimmer-DesktopLayout"
    })
  });
};

/* harmony default export */ var InsuranceLanding_InsuranceLandingShimmer = (InsuranceLandingShimmer);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/index.ts
var XDMAnalytics = __webpack_require__(354);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/pages/InsuranceLanding/InsuranceLanding.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// import "pwa-mmt-ui-header/ssr/header.css";

















var analytics = (0,insurance/* getAnalytics */.I)();

var InsuranceLanding = function InsuranceLanding(_ref) {
  var data = _ref.data,
      setActiveModal = _ref.setActiveModal;
  var context = (0,hooks/* usePartnerContext */.X)();
  var experiment = (0,react.useContext)(src/* ExperimentTrackingString */.Mq) || "";
  if (!data) return /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceLanding_InsuranceLandingShimmer, {
    "data-test-id": "InsuranceLanding-InsuranceLandingShimmer"
  });

  var _ref2 = data || {},
      title = _ref2.title,
      claimSettlementText = _ref2.claimSettlementText,
      secureTravData = _ref2.secureTravData,
      travellingTo = _ref2.travellingTo,
      calendarDatesLimit = _ref2.calendarDatesLimit,
      upcomingTrip = _ref2.upcomingTrip,
      upcomingTripsV2 = _ref2.upcomingTripsV2,
      errorFields = _ref2.errorFields,
      footer = _ref2.footer,
      travelSearchBanner = _ref2.travelSearchBanner,
      nextPageRoute = _ref2.nextPageRoute,
      pageAnalytics = _ref2.analytics;

  var device = (0,src/* useBreakpointV2 */.bU)();

  var _useState = (0,react.useState)(false),
      isLoggedIn = _useState[0],
      setIsLoggedIn = _useState[1];

  (0,react.useEffect)(function () {
    var _travellingTo$travelS, _travellingTo$travelS2;

    var queryParams = new URLSearchParams(window.location.search);
    var selectedCountries = queryParams.get("countries");
    var selectedCountryCodes = selectedCountries === null || selectedCountries === void 0 ? void 0 : selectedCountries.split(",");
    var segmentType = queryParams.get("segment");
    var countryData = (travellingTo === null || travellingTo === void 0 ? void 0 : (_travellingTo$travelS = travellingTo.travelSearchForm) === null || _travellingTo$travelS === void 0 ? void 0 : (_travellingTo$travelS2 = _travellingTo$travelS.regionCountryList) === null || _travellingTo$travelS2 === void 0 ? void 0 : _travellingTo$travelS2.value) || [];
    var totalCountryData = countryData === null || countryData === void 0 ? void 0 : countryData.map(function (data) {
      if (selectedCountryCodes !== null && selectedCountryCodes !== void 0 && selectedCountryCodes.includes(data.code)) {
        return _objectSpread(_objectSpread({}, data), {}, {
          isSelected: true
        });
      }

      return _objectSpread({}, data);
    });
    var selectedCountry = totalCountryData === null || totalCountryData === void 0 ? void 0 : totalCountryData.filter(function (item) {
      return item.isSelected;
    });

    if (countryData !== null && countryData !== void 0 && countryData.length) {
      localStorage.setItem("TRAVEL_INSURANCE_COUNTRIES", JSON.stringify(countryData));
    }

    if (data) {
      if (pageAnalytics !== null && pageAnalytics !== void 0 && pageAnalytics.pageLoad) {
        analytics === null || analytics === void 0 ? void 0 : analytics.trackRawPageLoadEvent(pageAnalytics.pageLoad);
      } else {
        analytics === null || analytics === void 0 ? void 0 : analytics.trackPageLoadEvent({
          pageName: "LANDING",
          experiment: experiment
        });
      }

      (0,XDMAnalytics.initializePageTracking)({
        page_context: {
          page_name: "landing",
          page_type: "landing",
          funnel_step: "landing",
          subpage_name: "seo_landing".concat(data !== null && data !== void 0 && data.travelCountry ? ":".concat(data === null || data === void 0 ? void 0 : data.travelCountry) : "")
        }
      }, {
        countries: selectedCountry ? selectedCountry : [],
        journeyType: segmentType || "",
        travellers: parseInt(queryParams.get("travellers") || "1"),
        fromDateTime: queryParams.get("startDate") ? parseInt(queryParams.get("startDate") || "0") : 0,
        toDateTime: queryParams.get("endDate") ? parseInt(queryParams.get("endDate") || "0") : 0
      });
    }
  }, [data]);
  (0,react.useEffect)(function () {
    var authCookie = (0,utils/* getCookieByName */.A7)("mmt-auth") || (0,utils/* getCookieByName */.A7)("OAUTH-GOIBIBO");
    setIsLoggedIn(!!authCookie);
  }, []);

  var goToMyOrders = function goToMyOrders() {
    analytics === null || analytics === void 0 ? void 0 : analytics.trackLandingEvents({
      actionType: "my_orders_clicked"
    } //"click"
    );
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "my_orders_clicked"
      }
    });
    var authCookie = (0,utils/* getCookieByName */.A7)("mmt-auth") || (0,utils/* getCookieByName */.A7)("OAUTH-GOIBIBO");

    if (authCookie) {
      navigation/* navigationActionsSeo.navigateToOrderListing */.Ro.navigateToOrderListing();
    } else {
      setActiveModal === null || setActiveModal === void 0 ? void 0 : setActiveModal("LOGIN");
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceLanding_PreloadImages, {
      data: data,
      "data-test-id": "InsuranceLanding-PreloadImages"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* DesktopLayout */.S_, {
      landingPageProp: true,
      title: title,
      height: device == "lg" ? "720px" : "",
      rightSectionHeight: "unset",
      leftSectionHeight: true,
      landingMargin: true,
      goToMyOrders: goToMyOrders,
      showMyOrders: isLoggedIn,
      leftComp: /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(static_components/* FlexComp */.bA, {
          margin: device == "sm" ? "0 0 0px" : context ? "-30px 0 0" : "",
          alignItems: "center",
          gap: "6px",
          "data-test-id": "InsuranceLanding-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* ImageComponent */.cu, {
            width: "12px",
            height: "16px",
            src: claimSettlementText === null || claimSettlementText === void 0 ? void 0 : claimSettlementText.icon,
            loading: "eager",
            "data-test-id": "InsuranceLanding-ImageComponent"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* SpanTag */.pF, {
            fontSize: "xs",
            fontWeight: "bold",
            color: Global/* theme.blackText */.rS.blackText,
            "data-test-id": "InsuranceLanding-SpanTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* FormattedText */.rc, {
              value: claimSettlementText === null || claimSettlementText === void 0 ? void 0 : claimSettlementText.title,
              "data-test-id": "InsuranceLanding-FormattedText"
            })
          })]
        }), device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components.SecureTravOffer, {
          data: secureTravData,
          "data-test-id": "InsuranceLanding-SecureTravOffer"
        }) : ""]
      }),
      rightComp: /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingPageRightWrapper, {
        "data-test-id": "InsuranceLanding-LandingPageRightWrapper",
        children: [upcomingTripsV2 && /*#__PURE__*/(0,jsx_runtime.jsx)(components.DomesticTrip, {
          title: upcomingTripsV2 === null || upcomingTripsV2 === void 0 ? void 0 : upcomingTripsV2.title,
          trips: upcomingTripsV2 === null || upcomingTripsV2 === void 0 ? void 0 : upcomingTripsV2.trips,
          "data-test-id": "InsuranceLanding-DomesticTrip"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.TravellingTo, {
          travelSearchBanner: travelSearchBanner,
          travellingToSection: travellingTo,
          upcomingTrip: upcomingTrip,
          calendarDatesLimit: calendarDatesLimit,
          nextPageRoute: nextPageRoute,
          errorFields: errorFields,
          countryCodes: data.countryCode,
          setLoginModal: setActiveModal,
          "data-test-id": "InsuranceLanding-TravellingTo"
        }), device != "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SecureTravOffer, {
          data: secureTravData,
          "data-test-id": "InsuranceLanding-SecureTravOffer"
        })]
      }),
      bottomComp: /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceLanding_InsuranceBottomComp, {
        bottomCompData: data,
        footerInfo: footer,
        "data-test-id": "InsuranceLanding-InsuranceBottomComp"
      }),
      "data-test-id": "InsuranceLanding-DesktopLayout"
    })]
  });
};

/* harmony default export */ var InsuranceLanding_InsuranceLanding = (InsuranceLanding);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/pages/index.tsx


// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/Contexts/PartnerContext.tsx
var PartnerContext = __webpack_require__(6965);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/Contexts/index.ts

// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hoc/index.ts + 2 modules
var hoc = __webpack_require__(3837);
// EXTERNAL MODULE: ../../libs/ui/src/lib/hoc/index.ts + 49 modules
var lib_hoc = __webpack_require__(1572);
// EXTERNAL MODULE: ../../node_modules/pwa-mmt-ui-header/ssr/header.css
var header = __webpack_require__(4766);
// EXTERNAL MODULE: ./src/hoc/index.ts + 1 modules
var src_hoc = __webpack_require__(8367);
;// CONCATENATED MODULE: ./pages/travel-insurance/index.tsx













var travel_insurance_analytics = (0,insurance/* getAnalytics */.I)();
var __N_SSP = true;
function LandingPage(_ref) {
  var _data$analytics, _data$offers, _data$offers$items, _data$offers$items$, _commonsHeaderData$he, _commonsHeaderData$lo, _commonsHeaderData$wa, _commonsHeaderData$mo, _commonsHeaderData$us;

  var data = _ref.data,
      _ref$device = _ref.device,
      device = _ref$device === void 0 ? "mobile" : _ref$device,
      error = _ref.error,
      partner = _ref.partner,
      referrer = _ref.referrer,
      commonsHeaderData = _ref.commonsHeaderData;
  var headTags = (data === null || data === void 0 ? void 0 : data.headTags) || {};

  var _useState = (0,react.useState)(""),
      activeModal = _useState[0],
      setActiveModal = _useState[1];

  (0,insurance/* setLandingPageAnalytics */.Q)(data === null || data === void 0 ? void 0 : (_data$analytics = data.analytics) === null || _data$analytics === void 0 ? void 0 : _data$analytics.pageLoad);
  var longImageUrl = data === null || data === void 0 ? void 0 : (_data$offers = data.offers) === null || _data$offers === void 0 ? void 0 : (_data$offers$items = _data$offers.items) === null || _data$offers$items === void 0 ? void 0 : (_data$offers$items$ = _data$offers$items[0]) === null || _data$offers$items$ === void 0 ? void 0 : _data$offers$items$.image_url;

  var goToMyOrders = function goToMyOrders() {
    travel_insurance_analytics === null || travel_insurance_analytics === void 0 ? void 0 : travel_insurance_analytics.trackLandingEvents({
      actionType: "my_orders_clicked"
    } //'click'
    );
    var authCookie = (0,utils/* getCookieByName */.A7)("mmt-auth") || (0,utils/* getCookieByName */.A7)("OAUTH-GOIBIBO");

    if (authCookie) {
      navigation/* navigationActionsSeo.navigateToOrderListing */.Ro.navigateToOrderListing();
    } else {
      setActiveModal === null || setActiveModal === void 0 ? void 0 : setActiveModal("LOGIN");
    }
  }; // TODO: move header configurations to context


  var component = partner === isomorphic_utils_src.PARTNER.GI ? (0,lib_hoc/* withGIInsuranceHeader */.HC)( /*#__PURE__*/(0,jsx_runtime.jsx)(PartnerContext/* PartnerContextProvider */.L, {
    partnerType: isomorphic_utils_src.PARTNER.GI,
    "data-test-id": "component-PartnerContextProvider",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceLanding_InsuranceLanding, {
      setActiveModal: setActiveModal,
      data: data,
      "data-test-id": "component-InsuranceLanding"
    })
  }), {
    Wrapper: InsuranceGiLandingPageMainWrapper,
    forceLogin: activeModal ? true : false
  }, "Secure International Travel", true, goToMyOrders, false, false) : (0,lib_hoc/* withMMTInsuranceHeader */.ZA)( /*#__PURE__*/(0,jsx_runtime.jsx)(PartnerContext/* PartnerContextProvider */.L, {
    partnerType: isomorphic_utils_src.PARTNER.MMT,
    "data-test-id": "component-PartnerContextProvider",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceLanding_InsuranceLanding, {
      setActiveModal: setActiveModal,
      data: data,
      "data-test-id": "component-InsuranceLanding"
    })
  }), {
    type: "dualHeader",
    Wrapper: InsuranceLandingPageMainWrapper,
    activeModal: activeModal ? "LOGIN" : undefined,
    onModalChange: function onModalChange(modal) {
      return setActiveModal(modal);
    },
    globalConfig: commonsHeaderData === null || commonsHeaderData === void 0 ? void 0 : (_commonsHeaderData$he = commonsHeaderData.headerConfig) === null || _commonsHeaderData$he === void 0 ? void 0 : _commonsHeaderData$he.value,
    headerCommonData: {
      loyaltyHeaderData: commonsHeaderData === null || commonsHeaderData === void 0 ? void 0 : (_commonsHeaderData$lo = commonsHeaderData.loyaltyHeaderData) === null || _commonsHeaderData$lo === void 0 ? void 0 : _commonsHeaderData$lo.value,
      walletHeaderData: commonsHeaderData === null || commonsHeaderData === void 0 ? void 0 : (_commonsHeaderData$wa = commonsHeaderData.walletHeaderData) === null || _commonsHeaderData$wa === void 0 ? void 0 : _commonsHeaderData$wa.value,
      mobileCore: commonsHeaderData === null || commonsHeaderData === void 0 ? void 0 : (_commonsHeaderData$mo = commonsHeaderData.mobileCore) === null || _commonsHeaderData$mo === void 0 ? void 0 : _commonsHeaderData$mo.value,
      userInfoData: commonsHeaderData === null || commonsHeaderData === void 0 ? void 0 : (_commonsHeaderData$us = commonsHeaderData.userInfoData) === null || _commonsHeaderData$us === void 0 ? void 0 : _commonsHeaderData$us.value
    }
  }, "Secure International Travel", true, goToMyOrders, false, false, false, false);
  return (0,lib_hoc/* withError */.AQ)((0,hoc/* withReferrerProvider */.ut)((0,src/* withDeviceAndThemeProvider */.OM)((0,src_hoc/* withSeoHeadTags */._)(component, headTags, partner, longImageUrl), device, {
    pageTheme: partner
  }), referrer), error, "LANDING");
}
/* harmony default export */ var travel_insurance = (LandingPage);

/***/ }),

/***/ 4766:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);